import { render, staticRenderFns } from "./carbonLabeling.vue?vue&type=template&id=25877bd5&scoped=true"
import script from "./carbonLabeling.vue?vue&type=script&lang=js"
export * from "./carbonLabeling.vue?vue&type=script&lang=js"
import style0 from "./carbonLabeling.vue?vue&type=style&index=0&id=25877bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25877bd5",
  null
  
)

export default component.exports